export const MSW_RESPONSE_DELAY = process.env.NODE_ENV === 'test' ? 0 : 1000

export const REACT_QUERY_KEYS = {
  HOME: ['home'],
  TRANSACTIONS: ['transactions'],
}

export const LIMIT_ROWS = 250
export const BOX_HEIGHT = 500
export const LIMIT_ROWS_MORO_SCROLL = 250
export const LIMIT_ROWS_NO_MORE_SCROLL = 250
export const END_REACHED_THRESHOLD_PERCENTAGE = 95
